import { defineStore } from "pinia";

export const useSystemStore = defineStore("system", {
  state: () => ({
    systemType: "eval", // 默认考评系统
  }),
  persist: true,
});
